import { cfCall } from "../../utils/apiProxy";

export const removeEmojis = (text: string) => {
  const emojiRegex =
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;
  return text.replace(emojiRegex, "");
};

export function hasEmoji(str: string) {
  const emojiRegex =
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;
  return emojiRegex.test(str);
}

export function formatDate(dateString: string | null | undefined) {
  // Пустая дата — это «юзер её не ставил», а не 1 января 1970: `new Date(null)`
  // даёт эпоху, и именно она раньше светилась в карточках фото.
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return dateString;
  }
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

export function formatDate2(dateString: string | number | Date) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hour = date.getHours().toString().padStart(2, "0");
  const mins = date.getMinutes().toString().padStart(2, "0");
  return `${day}.${month}.${year} ${hour}:${mins}`;
}

// Universal date formatter for action dates (handles Firestore Timestamp, ISO string, Date)
export function formatActionDate(dateValue: any): string {
  if (!dateValue) return "";

  let date: Date;

  // Firestore Timestamp object
  if (dateValue?.seconds !== undefined) {
    date = new Date(dateValue.seconds * 1000);
  }
  // Firestore Timestamp with toDate method
  else if (typeof dateValue?.toDate === "function") {
    date = dateValue.toDate();
  }
  // ISO string or other parseable format
  else {
    date = new Date(dateValue);
  }

  if (isNaN(date.getTime())) {
    return String(dateValue);
  }

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hour = date.getHours().toString().padStart(2, "0");
  const mins = date.getMinutes().toString().padStart(2, "0");
  return `${day}.${month}.${year} ${hour}:${mins}`;
}

export const convertTimestampToDate = (timestamp: {
  seconds: number;
  nanoseconds: number;
}) => {
  return new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
};

export async function checkAndCorrectGrammar(text: string, prompt?: string) {
  const r = await cfCall("correctGrammar", {
    method: "POST",
    body: { text, prompt },
  });

  const data = await r.json();
  if (!r.ok) {
    const msg = data?.error?.message || data?.error || "Unknown error";
    throw new Error(msg);
  }
  return data.result as string;
}

export function drawTextOnCanvas(
  text: string,
  fontSize: number,
  fontFamily: string
): HTMLCanvasElement | undefined {
  const canvas = document.createElement("canvas");
  canvas.width = 2392;
  canvas.height = 231;
  const ctx = canvas.getContext("2d");
  if (ctx) {
    ctx.font = `${fontSize}px ${fontFamily}`;
    ctx.fillText(text, 0, 170);
    return canvas;
  }
  return undefined;
}

export const preventDragHandler = (e: { preventDefault: () => void }) => {
  e.preventDefault();
};

export const getChapter = (templateId: string, index: number) => {
  if (templateId === "65dda647dc778d94d0928969") {
    if (index <= 83) return "Мы";
    else if (index <= 129) return "Она";
    else return "Что если..";
  } else if (templateId === "660e02b2ce933929f288c10c") {
    if (index <= 82) return "Мы";
    else if (index <= 128) return "Он";
    else return "Что если..";
  } else if (templateId === "65ec32bffc68f8ec35c47182") {
    if (index <= 82) return "Мы";
    else if (index <= 128) return "Он";
    else return "Что если..";
  } else if (templateId === "66163e630f78aa6b9f522b09") {
    if (index <= 89) return "Біз";
    else if (index <= 137) return "Ол";
    else return "Егер де..";
  } else if (templateId === "660e255e4d408cc2c1155322") {
    if (index <= 82) return "Мы";
    else if (index <= 128) return "Он";
    else return "Что если..";
  } else if (templateId === "66137cae18ab6072f1cea1df") {
    if (index <= 82) return "We";
    else if (index <= 128) return "He";
    else return "What if..";
  }
  return undefined;
};

export const getPredislovie = (
  templateId: string,
  partnerName: string,
  authorName: string
) => {
  const pn = partnerName?.split(" ")[0] || "";
  const an = authorName?.split(" ")[0] || "Автор";

  if (
    templateId === "65dda647dc778d94d0928969" ||
    templateId === "660e255e4d408cc2c1155322"
  ) {
    return (
      "Приветствуем вас!\n\nЕсли вы читаете эти строки, значит, ваш близкий\nчеловек решился на неожиданный шаг, посвятив\nвам собственную книгу. Этот труд посвящен вам,\n" +
      pn +
      ".\n\n" +
      an +
      " вложил в эту книгу свое сердце, время\nи душу, тщательно отбирая каждое слово, чтобы\nпередать всю глубину своих чувств к вам.\n\nЭта книга - это больше чем просто набор слов.\nВ ней вы найдете эпизоды смеха, радости,\nиспытаний и побед, сплетенные воедино, как\nвечное напоминание о любви, которая не знает\nграниц. Приятного чтения!\n\nС любовью,\nComabooks Publishing House"
    );
  } else if (
    templateId === "660e02b2ce933929f288c10c" ||
    templateId === "65ec32bffc68f8ec35c47182"
  ) {
    return (
      "Приветствуем вас!\n\nЕсли вы читаете эти строки, значит, ваш близкий\nчеловек решился на неожиданный шаг, посвятив\nвам собственную книгу. Этот труд посвящен вам,\n" +
      pn +
      ".\n\n" +
      an +
      " вложила в эту книгу свое сердце, время\nи душу, тщательно отбирая каждое слово, чтобы\nпередать всю глубину своих чувств к вам.\n\nЭта книга - это больше чем просто набор слов.\nВ ней вы найдете эпизоды смеха, радости,\nиспытаний и побед, сплетенные воедино, как\nвечное напоминание о любви, которая не знает\nграниц. Приятного чтения!\n\nС любовью,\nComabooks Publishing House"
    );
  } else if (templateId === "66163e630f78aa6b9f522b09") {
    return (
      "Сәлеметсіз бе!\n\nЕгер сіз бұл кітапті оқитын болсаңыз, онда сіздің\nжақын адамыңыз күтпеген қадамға барып, өз\nқолымен кітап жазып шықты деген сөз. " +
      pn +
      ",\nбұл туынды толықтай сізге арналған.\n\n" +
      an +
      " бұл кітапқа өзінің жүрегін, уақыты мен\nжан дүниесін салып, сізге деген сезімінің\nтереңдігін жеткізу үшін әрбір сөзді мұқият таңдаған.\n\nБұл кітап жай сөздер жиынтығы емес. Мұнда сіз\nараңыздағы шексіз махаббаты дәлелдегіш күлкі,\nқуаныш, қиындықтар мен жеңіс сәттерін\nтаба аласыз. Оқудан ләззат алыңыз!\n\nМахаббатпен,\nComabooks Publishing House"
    );
  } else {
    return (
      "Приветствуем вас!\n\nЕсли вы читаете эти строки, значит, ваш близкий\nчеловек решился на неожиданный шаг, посвятив\nвам собственную книгу. Этот труд посвящен вам,\n" +
      pn +
      ".\n\n" +
      an +
      " вложил в эту книгу свое сердце, время\nи душу, тщательно отбирая каждое слово, чтобы\nпередать всю глубину своих чувств к вам.\n\nЭта книга - это больше чем просто набор слов.\nВ ней вы найдете эпизоды смеха, радости,\nиспытаний и побед, сплетенные воедино, как\nвечное напоминание о любви, которая не знает\nграниц. Приятного чтения!\n\nС любовью,\nComabooks Publishing House"
    );
  }
};
